import React, { useEffect, useState } from "react";
import axios from "axios";
import { isAutheticated } from "../auth/authhelper";
import { API } from "../../API";
import { useHistory, Link } from "react-router-dom"; // Updated to useNavigate
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function TractionInvoices() {
    const history = useHistory()
    const { token } = isAutheticated();

    const [payments, setPayments] = useState([]);
    const [filters, setFilters] = useState({ month: "" });

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(15);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    // ----------------------------------------------------
    // 👉 Fetch Subscription Invoices
    // ----------------------------------------------------
    const fetchInvoices = async (page = 1) => {
        try {
            setLoading(true);

            const params = {
                page,
                limit: rowsPerPage,
                ...filters,
                id: "all",
                invoiceFor: "traction_Provider", // Matching your backend controller
            };

            const res = await axios.get(`${API}/api/invoices/getmy/traction_invoices`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (res.data.success) {
                setPayments(res.data.invoices || []);
                setTotalPages(res.data.totalPages || 1);
            }
        } catch (err) {
            console.error("Error fetching invoices:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInvoices(currentPage);
    }, [currentPage, filters]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">Traction One Time Setup Fees</h4>

                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard">SoComOTT</Link>
                                        </li>
                                        <li className="breadcrumb-item active">
                                            Traction One Time Setup Fees
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-lg-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className="table-responsive">
                                    <table className='table table-centered table-nowrap mb-2'>
                                        <thead className='thead-light'>
                                            <tr className="text-center">
                                                <th>#</th>
                                                <th>Channel</th>
                                                <th>Type</th>
                                                <th>Invoice No</th>
                                                <th>Date</th>
                                                <th>Amount</th>
                                                <th>Status</th>
                                                <th>Action Items</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="8" className="text-center py-4">
                                                        <strong>Loading invoices...</strong>
                                                    </td>
                                                </tr>
                                            ) : payments.length > 0 ? (
                                                payments.map((p, idx) => (
                                                    <tr key={p._id} className="text-center">
                                                        <td>{(currentPage - 1) * rowsPerPage + idx + 1}</td>

                                                        <td>
                                                            {/* Uses flattened names from the controller mapping */}
                                                            {p.subchannelName || p.network_channelName || "—"}
                                                        </td>

                                                        <td>
                                                            {p.subchannelId ? "Channel" : "Net. Channel"}
                                                        </td>

                                                        <td className="">{p.invoiceNumber}</td>

                                                        <td>
                                                            {new Date(p.createdAt).toLocaleDateString("en-US", {
                                                                day: "2-digit", month: "short", year: "numeric",
                                                            })}
                                                        </td>

                                                        <td className="font-weight-bold">
                                                            {p.CurrencySymbole ? p.CurrencySymbole : "$"}{p.amount}
                                                            {/* {p.currency === "INR" ? "₹" : "$"}{p.amount.toLocaleString()} */}
                                                        </td>

                                                        <td>
                                                            <span className={`badge ${p.status === "paid" ? "bg-success" : "bg-warning"}`}>
                                                                {p.status.toUpperCase()}
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <div className="d-flex justify-content-center gap-2">
                                                                <button
                                                                    className="btn btn-primary btn-sm"
                                                                    onClick={() => history.push(`/traction_provider/invoice/${p._id}`)}
                                                                >
                                                                    View
                                                                </button>
                                                                <button className="btn btn-warning btn-sm">
                                                                    Traction
                                                                </button>
                                                                <button className="btn btn-danger btn-sm">
                                                                    Analytics
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center py-3">No invoices found.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* ---------------- PAGINATION ---------------- */}
                                {totalPages > 1 && !loading && (
                                    <nav className="mt-3">
                                        <ul className="pagination justify-content-center">
                                            {[...Array(totalPages)].map((_, i) => (
                                                <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => handlePageChange(i + 1)}
                                                    >
                                                        {i + 1}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </nav>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}